export default __webpack_public_path__ + "static/media/airdockz-blk-4.d51b13d1.png";